import {
  Box,
  Checkbox,
  DialogContent,
  FormControlLabel,
  Grid,
  MenuItem,
  Typography,
} from "@mui/material";
import CommonFilterDialog from "app/components/common/Dialogs/CommonFilterDialog";
import FilterButton from "app/components/common/FilterButton";
import { getAllLibraryDistinctValues } from "app/services/schoolReportingServices/library.service";
import { CustomSelectBox } from "assets/styles/globalStyledComponent";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { toast } from "react-toastify";

const FILTER_FIELDS = [
  { key: "category", label: "Category", apiKey: "distinctCategory" },
  { key: "author", label: "Author", apiKey: "distinctAuthor" },
  { key: "publisher", label: "Publisher", apiKey: "distinctPublisher" },
  { key: "edition", label: "Edition", apiKey: "distinctEdition" },
  { key: "publishYear", label: "Publish Year", apiKey: "distinctPublishYear" },
];

const FilterLibraryDialog = ({ mutate = () => {}, loading = false }) => {
  const [state, setState] = useState({
    filterDialog: false,
    distincts: {},
    selected: {
      category: [],
      author: [],
      publisher: [],
      edition: [],
      publishYear: [],
    },
  });

  // Fetch distinct values for dropdowns
  useQuery({
    queryKey: ["getAllLibraryDistinctValues"],
    queryFn: () => getAllLibraryDistinctValues(),
    onSuccess: (success) => {
      setState((prev) => ({
        ...prev,
        distincts: success?.data || {},
      }));
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message ?? "Something went wrong");
    },
  });

  // --- Dialog Handlers ---
  const handleOpenFilterDialog = () => {
    setState((prev) => ({ ...prev, filterDialog: true }));
  };
  const handleCloseFilterDialog = () => {
    setState((prev) => ({ ...prev, filterDialog: false }));
  };

  // --- Select Change Handler ---
  const handleSelectChange = (key) => (e) => {
    setState((prev) => ({
      ...prev,
      selected: {
        ...prev.selected,
        [key]: e.target.value,
      },
    }));
  };

  // --- Clear All Filters ---
  const handleClear = () => {
    setState((prev) => ({
      ...prev,
      selected: {
        category: [],
        author: [],
        publisher: [],
        edition: [],
        publishYear: [],
      },
    }));
  };

  // --- Save & View Handler ---
  const handleView = () => {
    handleCloseFilterDialog();
    const params = {};
    FILTER_FIELDS.forEach(({ key }) => {
      if (state.selected[key]?.length > 0) {
        params[`${key}List`] = JSON.stringify(state.selected[key]);
      }
    });
    mutate(params);
  };

  return (
    <>
      <FilterButton
        hanldeClick={() =>
          setState((prev) => ({ ...prev, filterDialog: true }))
        }
        count={Object.values(state.selected).reduce(
          (acc, arr) => acc + (arr?.length || 0),
          0
        )}
      />

      <CommonFilterDialog
        open={state.filterDialog}
        onClose={handleCloseFilterDialog}
        title="Filter Library"
        loading={loading}
        handleSaveAndView={handleView}
        minWidth="500px"
      >
        <DialogContent>
          <Grid container spacing={2}>
            {FILTER_FIELDS.map(({ key, label, apiKey }) => (
              <Grid item xs={12} md={6} key={key}>
                <Typography sx={{ fontWeight: 600, mb: 0.5 }}>
                  {label}
                </Typography>
                <CustomSelectBox
                  displayEmpty
                  size="small"
                  fullWidth
                  multiple
                  value={state.selected[key]}
                  onChange={handleSelectChange(key)}
                  renderValue={(selected) =>
                    selected.length > 0
                      ? selected.join(", ")
                      : `Select ${label}`
                  }
                >
                  <MenuItem disabled value="">
                    Select {label}
                  </MenuItem>
                  {(state.distincts[apiKey] || []).map((item, idx) => (
                    <MenuItem key={idx} value={item}>
                      <Checkbox
                        checked={state.selected[key].includes(item)}
                        color="secondary"
                      />
                      {item}
                    </MenuItem>
                  ))}
                </CustomSelectBox>
              </Grid>
            ))}
          </Grid>
          <Box mt={2} display="flex" justifyContent="flex-end">
            <Typography
              sx={{
                color: "#28789c",
                fontSize: "15px",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={handleClear}
            >
              Clear All
            </Typography>
          </Box>
        </DialogContent>
      </CommonFilterDialog>
    </>
  );
};

export default FilterLibraryDialog;
